import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";

import ConditionalButton from "../../../layout/conditional-button";
import Table from "../../../layout/table";
import { canManageFeradelAdministration, canViewFeradelAdministration } from "../../../constants/permissions";
import { sourceList } from "../../../actions/areas";
import { currency as formatCurrency } from "../../../utils/number";

class Areas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 25,
            search: "",
            order: "name",
            index: 0,
            direction: "ASC",
            data: [],
            pages: 0
        };
    }

    componentDidMount = () => {
        this.fetchData();
    }

    componentDidUpdate = (oldProps) => {
        const oldPermissions = (oldProps.auth?.permissions || []).join("|");
        const newPermissions = (this.props.auth?.permissions || []).join("|");
        if (oldPermissions !== newPermissions && this.canViewAreas && this.state.data.length === 0) {
            this.fetchData();
        }
    }

    get canViewAreas() {
        return canViewFeradelAdministration(this.props.auth?.permissions);
    }

    get canManageAreas() {
        return canManageFeradelAdministration(this.props.auth?.permissions);
    }

    get headers() {
        return [
            {
                header: "Name",
                sortable: true,
                source: "name",
                className: "text-muted text-small text-uppercase w-35",
                onFormat: this.onLinkFormat
            },
            {
                header: "Abbreviation",
                sortable: true,
                source: "abbreviation",
                className: "text-muted text-small text-uppercase w-15",
                onFormat: this.onLinkFormat
            },
            {
                header: "Population",
                sortable: true,
                source: "population",
                className: "text-muted text-small text-uppercase w-15 text-end"
            },
            {
                header: "Rate",
                sortable: true,
                source: "rate",
                className: "text-muted text-small text-uppercase w-10 text-end"
            },
            {
                header: "License Fee",
                sortable: true,
                source: "licenseFee",
                className: "text-muted text-small text-uppercase w-15 text-end",
                onFormat: this.onCurrencyFormat
            },
            {
                header: "Platform Fee",
                sortable: true,
                source: "platformFee",
                className: "text-muted text-small text-uppercase w-10 text-end"
            }
        ];
    }

    fetchData = async () => {
        if (!this.canViewAreas) return;

        const result = await this.props.sourceList({
            page: this.state.page,
            size: this.state.size,
            order: this.state.order,
            direction: this.state.direction,
            raw: 1,
            search: this.state.search
        });
        const data = result?.rows || [];
        const pages = data.length > 0 ? Math.ceil(Number(result.count || 0) / Number(this.state.size)) : 0;

        this.setState({ data, pages });
    }

    onCurrencyFormat = (e) => formatCurrency(Number(e));

    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/settings/areas/${row["uuid"]}">${e || ""}</a>`;
    }

    onColumnClick = (e) => {
        const headers = this.headers;
        const index = headers.findIndex((item) => item.header === e.header && item.source === e.source);

        this.setState({
            index,
            direction: this.state.index === index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: headers[index].source,
            page: 0
        }, this.fetchData);
    }

    onSearch = (e) => {
        this.setState({ search: e, page: 0 }, this.fetchData);
    }

    onSize = (e) => {
        this.setState({ page: 0, size: Number(e) }, this.fetchData);
    }

    onPageChange = (e) => {
        this.setState({ page: Number(e) }, this.fetchData);
    }

    onNewClick = () => {
        if (this.canManageAreas) window.location.href = "/dashboard/settings/areas/add";
    }

    render() {
        if (!this.canViewAreas) {
            return <Col xs="12">Area settings not available.</Col>;
        }

        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new area" display={this.canManageAreas} enabled={this.canManageAreas} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable
                        sizable
                    />
                </Col>
            </>
        );
    }
}

Areas.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { sourceList })(Areas);
